import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CheckboxList, Tooltip, Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const OptIns = ({ intl , availableOptIns , selectedOptIns , onChange , onSave , className , isUpdating  })=>{
    const handleChange = (selectedItems)=>{
        // `mappedOptIns` will return all availableOptIns with current values (enabled/disabled)
        const mappedOptIns = availableOptIns.reduce((selected, optIn)=>{
            return swcHelpers.objectSpread({}, selected, {
                [optIn.value]: {
                    checked: selectedItems && selectedItems.some((o)=>o.value === optIn.value
                    ),
                    label: intl.getLabel(optIn.titleKey) || optIn.value
                }
            });
        }, {});
        onChange(mappedOptIns);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CheckboxList, {
        className: className,
        items: availableOptIns,
        idPrefix: "__opt-in_",
        renderItem: (item)=>/*#__PURE__*/ React.createElement("span", {
                className: "opt-ins__text"
            }, intl.getFormattedLabel(item.titleKey, {
                parseHTML: true
            }))
        ,
        renderTrailingItem: (item)=>item.tooltipKey && /*#__PURE__*/ React.createElement(Tooltip, {
                id: item.titleKey,
                message: intl.getLabel(item.tooltipKey, {
                    hideLabelKey: true
                }),
                className: "opt-ins__tooltip"
            })
        ,
        getItemIdentifier: (item)=>item.value
        ,
        selectedItems: selectedOptIns,
        onChange: handleChange
    }), /*#__PURE__*/ React.createElement(Text, {
        className: "opt-ins__data-processing-disclaimer",
        variant: "caption"
    }, intl.getFormattedLabel('account.consent.dataProcessing', {
        parseLink: true
    })), /*#__PURE__*/ React.createElement(Button, {
        size: "medium",
        className: "opt-ins__save-button",
        caption: intl.getLabel('account.action.save'),
        disabled: isUpdating,
        "data-t": "save-consent",
        onClick: onSave
    }));
};

export { OptIns };
//# sourceMappingURL=OptIns.js.map
